import request from '../utils/request';

export const getDistributorList = (params) => request.get('/admin/distribution/distributors', { params });
export const getDistributorDetail = (id) => request.get(`/admin/distribution/distributors/${encodeURIComponent(id)}`);
export const updateDistributorStatus = (id, data) =>
  request.put(`/admin/distribution/distributors/${encodeURIComponent(id)}/status`, data);
export const getDistributionTree = (userId) =>
  request.get(`/admin/distribution/tree/${encodeURIComponent(userId)}`);

export const getCommissionList = (params) => request.get('/admin/distribution/commissions', { params });
export const settleCommission = (data) => request.post('/admin/distribution/commissions/settle', data);

export const getDistributionStats = (params) => request.get('/admin/distribution/stats', { params });
export const getDistributionConfig = () => request.get('/admin/distribution/config');
export const updateDistributionConfig = (data) => request.put('/admin/distribution/config', data);
